import * as React from 'react';

import { translate } from '~l10n/client';

import { JoinTeam } from '~teacher/components/JoinTeam';
import { useWorkspaceList } from '~teacher/hook/workspaces';
import {
  ConfirmStopRunningActivity,
  useConfirmStopRunningActivity,
} from '~teacher/launchv2/ConfirmLaunchQuiz/ConfirmLaunchQuiz';
import { LaunchDialog, useLaunchDialog } from '~teacher/launchv2/LaunchDialog';

import LaunchExitTicketIcon from '../../../../shared/icons/LaunchExitTicketIcon';
import LaunchQuizIcon from '../../../../shared/icons/LaunchQuizIcon';
import LaunchSpaceRaceIcon from '../../../../shared/icons/LaunchSpaceRaceIcon';
import LaunchButton from '../components/LaunchButton';

const room = require('room');

const activity = require('../../../../../shared/models/activity');

export default function LaunchView({
  controller: {
    exitTicketClicked,
    mcClicked,
    saClicked,
    spaceRaceClicked,
    tfClicked,
  },
  inviteCode,
}: {
  controller: {
    exitTicketClicked: () => void;
    mcClicked: () => void;
    quizClicked: () => void;
    saClicked: () => void;
    spaceRaceClicked: () => void;
    tfClicked: () => void;
  };
  inviteCode?: string;
}) {
  const [confirmStopRunningActivity, dispatchConfirmStopRunningActivity] =
    useConfirmStopRunningActivity();
  const launchQuizDialog = useLaunchDialog();
  const workspaceLists = useWorkspaceList();
  if (!workspaceLists?.data) return null;

  const onLaunchQuiz = () => {
    if (activity.isLive()) {
      dispatchConfirmStopRunningActivity({
        type: 'open',
        payload: {
          openLaunchQuizDialog: () => {
            launchQuizDialog.open();
            dispatchConfirmStopRunningActivity({ type: 'close' });
          },
          onClose: () => dispatchConfirmStopRunningActivity({ type: 'close' }),
        },
      });
    } else {
      launchQuizDialog.open();
    }
  };

  const roomId = room.id;

  return (
    <>
      <div id="launch-container">
        <div className="launch-button-row-1">
          <LaunchButton
            icon={LaunchQuizIcon}
            svgClass="launch-quiz-icon"
            pathClass="launch-quiz-icon-path"
            label={translate('Quiz')}
            onClick={onLaunchQuiz}
          />
          <LaunchButton
            icon={LaunchSpaceRaceIcon}
            svgClass="launch-space-race-icon"
            pathClass="launch-space-race-icon-path"
            label={translate('Space Race')}
            onClick={spaceRaceClicked}
          />
          <LaunchButton
            icon={LaunchExitTicketIcon}
            svgClass="launch-exit-ticket-icon"
            pathClass="launch-exit-ticket-icon-path"
            label={translate('Exit Ticket')}
            onClick={exitTicketClicked}
          />
        </div>
        <div className="launch-button-row-2">
          <div className="quick-question-separator">
            <span className="quick-question-separator-text">
              {translate('Quick Question', true)}
            </span>
          </div>
          <LaunchButton
            className="mc-button"
            content="MC"
            label={translate('Multiple Choice')}
            onClick={mcClicked}
          />
          <LaunchButton
            className="tf-button"
            content="TF"
            label={translate('True / False')}
            onClick={tfClicked}
          />
          <LaunchButton
            className="sa-button"
            content="SA"
            label={translate('Short Answer')}
            onClick={saClicked}
          />
        </div>
      </div>
      <ConfirmStopRunningActivity
        activityInstanceId={activity.getId()}
        isOpen={confirmStopRunningActivity.isOpen}
        onClose={confirmStopRunningActivity.onClose}
        openLaunchQuizDialog={confirmStopRunningActivity.openLaunchQuizDialog}
      />
      <LaunchDialog
        initialRoomName={room.get('name')}
        initialRoomId={roomId}
        isRoomRostered={room.hasRoster()}
        onClose={launchQuizDialog.close}
        isOpen={launchQuizDialog.isOpen}
      />
      <JoinTeam inviteCode={inviteCode} />
    </>
  );
}
